import { create as Y } from "zustand";
import { persist as G, createJSONStorage as H } from "zustand/middleware";
import { useMemo as P, useCallback as y, useRef as D, useState as O } from "react";
import { useQueryClient as T, useQuery as k } from "@tanstack/react-query";
import { q as C, e as W, c as J, h as V, b as X, i as Z } from "./fetcher-CUYp7JR1.js";
import "idb";
const ie = [], $ = "neu-table-preferences-v1", Q = () => ({
  version: 1,
  updatedAt: Date.now(),
  columns: {
    order: [],
    visibility: {},
    widths: {}
  },
  filters: {},
  sorting: []
});
function E(s) {
  return {
    ...s,
    updatedAt: Date.now()
  };
}
const z = {
  order: [],
  visibility: {},
  customized: !1
};
function j(s) {
  return Object.keys(s.columns.widths).length > 0 || Object.keys(s.filters).length > 0 || s.sorting.length > 0;
}
function p(s) {
  const e = {};
  for (const [t, r] of Object.entries(s)) {
    if (r.columns.customized === !0) {
      e[t] = r;
      continue;
    }
    if (!(r.columns.order.length > 0 || Object.keys(r.columns.visibility).length > 0)) {
      e[t] = r;
      continue;
    }
    j(r) && (e[t] = E({
      ...r,
      columns: {
        ...r.columns,
        ...z
      }
    }));
  }
  return e;
}
const ue = Y()(
  G(
    (s, e) => ({
      tablePreferencesByKey: {},
      setColumnWidth: (t, r, n) => {
        const a = Math.max(96, Math.round(n)), { tablePreferencesByKey: i } = e(), u = i[t] ?? Q();
        s({
          tablePreferencesByKey: {
            ...i,
            [t]: E({
              ...u,
              columns: {
                ...u.columns,
                widths: {
                  ...u.columns.widths,
                  [r]: a
                }
              }
            })
          }
        });
      },
      saveColumnLayout: (t, r) => {
        const { tablePreferencesByKey: n } = e(), a = n[t] ?? Q();
        s({
          tablePreferencesByKey: {
            ...n,
            [t]: E({
              ...a,
              columns: {
                ...a.columns,
                order: r.order,
                visibility: r.visibility,
                customized: !0
              }
            })
          }
        });
      },
      clearColumnLayout: (t) => {
        const { tablePreferencesByKey: r } = e(), n = r[t];
        if (!(!n || !(n.columns.order.length > 0 || Object.keys(n.columns.visibility).length > 0 || n.columns.customized === !0))) {
          if (!j(n)) {
            const { [t]: i, ...u } = r;
            s({ tablePreferencesByKey: u });
            return;
          }
          s({
            tablePreferencesByKey: {
              ...r,
              [t]: E({
                ...n,
                columns: {
                  ...n.columns,
                  ...z
                }
              })
            }
          });
        }
      },
      setFilters: (t, r) => {
        const { tablePreferencesByKey: n } = e(), a = n[t] ?? Q();
        s({
          tablePreferencesByKey: {
            ...n,
            [t]: E({
              ...a,
              filters: r
            })
          }
        });
      },
      setSorting: (t, r) => {
        const { tablePreferencesByKey: n } = e(), a = n[t] ?? Q();
        s({
          tablePreferencesByKey: {
            ...n,
            [t]: E({
              ...a,
              sorting: r
            })
          }
        });
      },
      clearTablePreference: (t) => {
        const { tablePreferencesByKey: r } = e(), { [t]: n, ...a } = r;
        s({ tablePreferencesByKey: a });
      }
    }),
    {
      name: $,
      storage: H(() => localStorage),
      merge: (s, e) => {
        const t = s;
        return t != null && t.tablePreferencesByKey ? {
          ...e,
          tablePreferencesByKey: p(
            t.tablePreferencesByKey
          )
        } : e;
      }
    }
  )
);
function N(s, e) {
  const t = T(), {
    abortSignal: r,
    timeoutMs: n,
    refreshInterval: a,
    queryKey: i,
    ...u
  } = e || {}, b = !!s && (u.enabled ?? !0), l = P(
    () => i ?? (s ? C.path(s) : ["api", "disabled"]),
    [i, s]
  ), f = P(
    () => ({
      signal: r,
      timeoutMs: n
    }),
    [r, n]
  ), m = k({
    queryKey: l,
    enabled: b,
    refetchInterval: a,
    queryFn: () => {
      if (!s)
        throw new Error("useAPI: path is null");
      return W(J(s), f);
    },
    ...u
  }), d = y(
    () => t.invalidateQueries({ queryKey: l }),
    [l, t]
  ), h = y(async () => {
    await m.refetch();
  }, [m]), g = y(
    async (q) => {
      if (!b)
        return;
      if (typeof q > "u")
        return await t.invalidateQueries({ queryKey: l }), t.getQueryData(l);
      const B = await Promise.resolve(q);
      return t.setQueryData(l, B), B;
    },
    [b, l, t]
  ), v = D(m.refetch);
  v.current = m.refetch;
  const o = y(() => v.current(), []), K = P(
    () => ({
      mutate: g,
      invalidate: d,
      refresh: h,
      refetch: o
    }),
    [g, d, h, o]
  );
  return [m, K];
}
const le = N;
function ee(s, e, t) {
  const r = t ? { ...e, ...t } : e ?? {}, {
    page: n,
    limit: a,
    skip: i,
    filters: u,
    query: b,
    sort: l,
    fields: f,
    buildBaseListUrl: m,
    ...d
  } = r, h = P(
    () => ({
      page: n,
      limit: a,
      skip: i,
      filters: u,
      query: b,
      sort: l,
      fields: f,
      buildBaseListUrl: m
    }),
    [n, a, i, u, b, l, f, m]
  ), g = P(
    () => X(h),
    [h]
  ), v = d.enabled ?? !0, o = d.queryKey ?? C.entityList(s, g), { abortSignal: K, timeoutMs: q, refreshInterval: B, ...w } = d, L = P(
    () => ({ signal: K, timeoutMs: q }),
    [K, q]
  ), S = k({
    queryKey: o,
    enabled: v,
    refetchInterval: B,
    queryFn: () => Z(s, h, L),
    ...w
  }), c = T(), A = y(
    () => c.invalidateQueries({ queryKey: o }),
    [o, c]
  ), I = y(async () => {
    await S.refetch();
  }, [S]), M = y(
    async (R) => {
      if (!v)
        return;
      if (typeof R > "u")
        return await c.invalidateQueries({ queryKey: o }), c.getQueryData(o);
      const x = await Promise.resolve(R);
      return c.setQueryData(o, x), x;
    },
    [v, o, c]
  ), _ = D(S.refetch);
  _.current = S.refetch;
  const F = y(() => _.current(), []), U = P(
    () => ({
      mutate: M,
      invalidate: A,
      refresh: I,
      refetch: F
    }),
    [M, A, I, F]
  );
  return [S, U];
}
function oe(s, e) {
  var L, S;
  const [t, r] = O(
    () => (e == null ? void 0 : e.initialFilters) ?? {}
  ), [n, a] = O(() => (e == null ? void 0 : e.initialPage) ?? 1), [i, u] = O(() => (e == null ? void 0 : e.initialLimit) ?? 100), [b, l] = O(
    () => {
      var c;
      return (e == null ? void 0 : e.initialSort) ?? ((c = e == null ? void 0 : e.params) == null ? void 0 : c.sort);
    }
  ), f = P(
    () => ({
      ...(e == null ? void 0 : e.params) ?? {},
      page: n,
      limit: i,
      filters: t,
      ...b !== void 0 ? { sort: b } : {}
    }),
    [t, i, e == null ? void 0 : e.params, n, b]
  ), [m, d] = ee(
    s,
    f,
    e == null ? void 0 : e.queryOptions
  ), h = ((L = e == null ? void 0 : e.getHasNextPage) == null ? void 0 : L.call(e, m.data)) ?? !!((S = m.data) != null && S.nextPage), g = n > 1, v = y(() => {
    h && a((c) => c + 1);
  }, [h]), o = y(() => {
    a((c) => Math.max(1, c - 1));
  }, []), K = y((c) => {
    r(c), a(1);
  }, []), q = y((c) => {
    const A = Array.isArray(c) ? c : [c];
    l(A.length > 0 ? c : void 0), a(1);
  }, []), B = P(
    () => ({
      page: n,
      limit: i,
      setPage: a,
      setLimit: u,
      nextPage: v,
      prevPage: o,
      canGoPrev: g,
      hasNextPage: h
    }),
    [
      n,
      i,
      a,
      u,
      v,
      o,
      g,
      h
    ]
  ), w = P(
    () => ({
      ...d,
      setFilters: K,
      setSort: q
    }),
    [d, K, q]
  );
  return [m, B, w, f];
}
function ye(s, e, t) {
  const r = T(), { abortSignal: n, timeoutMs: a, refreshInterval: i, queryKey: u, ...b } = t || {}, l = e !== null && (b.enabled ?? !0), f = u ?? (e === null ? ["api", "disabled"] : C.entity(s, e)), m = P(
    () => ({ signal: n, timeoutMs: a }),
    [n, a]
  ), d = k({
    queryKey: f,
    enabled: l,
    refetchInterval: i,
    queryFn: () => {
      if (e === null)
        throw new Error("useEntity: id is null");
      return V(s, e, m);
    },
    ...b
  }), h = y(
    () => r.invalidateQueries({ queryKey: f }),
    [f, r]
  ), g = y(async () => {
    await d.refetch();
  }, [d]), v = y(
    async (B) => {
      if (!l)
        return;
      if (typeof B > "u")
        return await r.invalidateQueries({ queryKey: f }), r.getQueryData(f);
      const w = await Promise.resolve(B);
      return r.setQueryData(f, w), w;
    },
    [l, f, r]
  ), o = D(d.refetch);
  o.current = d.refetch;
  const K = y(() => o.current(), []), q = P(
    () => ({
      mutate: v,
      invalidate: h,
      refresh: g,
      refetch: K
    }),
    [v, h, g, K]
  );
  return [d, q];
}
function fe(s) {
  const [{ data: e, error: t, ...r }] = N("/definition", {
    abortSignal: s,
    refreshInterval: 9e5,
    staleTime: 0,
    retry: 3,
    retryDelay: 1e3
  });
  return {
    data: e || void 0,
    error: t,
    ...r
  };
}
export {
  ie as E,
  ye as a,
  N as b,
  ue as c,
  oe as d,
  le as e,
  ee as f,
  p as s,
  fe as u
};
